<template>
  <div class="title-image" id="news">
    <div class="title-text">
      <transition name="slide-title">
        <div v-show="showTitle">
          <h1>Auto Kolarovič</h1>
          <h2>
            Nabízíme pouze kvalitní a prověřená vozidla dovážená převážně z EU
            již od roku 2000
          </h2>
          <h3>Možnost sjednání havarijního pojištění přímo na místě</h3>
          <!--<button class="request-button" v-scroll-to="setScrollSettings()">Mám dotaz</button>-->
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      background_color: require("../../../assets/background_color.jpg"),
      showTitle: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.showTitle = true;
    }, 2000);
  },
  methods: {
    setScrollSettings() {
      return {
        el: "#request"
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../scss/global.scss";
.title-image {
  display: none;
}

@media (min-width: $min-width-extended) {
  .title-image {
    position: fixed;
    top: 6.9rem;
    left: 0;
    padding: 0;
    margin: 0;
    display: inline-block;
    width: 100%;
    height: 45rem;
    z-index: 0;
    background: #fff url("../../../assets/background_color.jpg") no-repeat fixed;
    -webkit-background-size: auto 39rem;
    -moz-background-size: auto 39rem;
    -o-background-size: auto 39rem;
    background-size: 100vw 39rem;
    background-position: right 0 top -4rem;
    .clearfix {
      overflow: hidden;
    }
    h1,
    h2,
    h3 {
      color: rgb(255, 255, 255);
      padding: 0.5rem 2rem;
    }
    h2 {
      font-size: 1.2rem;
    }
    div {
      text-align: left;
    }
    .title-text {
      position: absolute;
      top: 2rem;
      right: 6rem;
      width: 30rem;
      .slide-title-active {
        transform: translateX(56rem);
      }
      .slide-title-enter-active {
        animation: slide-title-in 1s ease-out forwards;
      }
      @keyframes slide-title-in {
        0% {
          transform: translateX(56rem);
        }
        60% {
          transform: translateX(-1rem);
        }
        80% {
          transform: translateX(1rem);
        }
        100% {
          transform: translateX(0);
        }
      }
    }
  }
}
</style>
